import { r as registerInstance, c as createEvent, h, g as getElement } from './index-d4808923.js';
import { g as global$1 } from './index.esm-7182addc.js';
import { g as gravityXSSWhitelist, l as lib, x as xss } from './gravity-xss-whitelist-53c2079f.js';

const gravityTableCss = ".table-container{background-color:#FFFFFF;border:1px solid rgba(0, 15, 30, 0.1);border-radius:8px;display:flex;flex-direction:column;overflow:hidden}.table-container .text{display:block}.table-container .text__container--clamp-single{max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.table-container .text__container--clamp-multi{-webkit-box-orient:vertical;display:-webkit-box;-webkit-line-clamp:2;overflow:hidden;}.table-container__scroll-area{height:100%;overflow:auto}.table-container .sort-button{align-items:center;background:none;border:0;color:inherit;cursor:pointer;display:flex;font:inherit;gap:4px;overflow:hidden;padding:0;text-align:left;width:100%}.table-container .sort-button .text{flex:0 1 auto;overflow:hidden}.table-container .sort-button .sort-button__icon{display:none;flex:0 0 auto}.table-container .sort-button.sort-button--sorted .sort-button__icon,.table-container .sort-button:hover .sort-button__icon{display:contents}.table-container .table{border-spacing:0;position:relative;table-layout:auto;width:100%}.table-container .table .selection-container{height:48px}.table-container .table .selection-container__spacer{min-width:24px;width:24px}.table-container .table .selection-container__spacer:empty{pointer-events:none}.table-container .table .selection-container__cell{padding-left:0;text-align:left}.table-container .table .selection-container__cell:last-child{padding-right:24px}.table-container .table .selection-container__row{align-items:center;display:inline-flex;justify-content:space-between;width:100%}.table-container .table .selection-container__spacer,.table-container .table .selection-container__row,.table-container .table .selection-container__cell{background-color:#F4F8FE;position:sticky;top:0}.table-container .table--fixed{table-layout:fixed}.table-container .table__head{position:relative}.table-container .table__head__row--columns{position:relative;z-index:1}.table-container .table__head__cell{border-bottom:1px solid rgba(0, 15, 30, 0.1);box-sizing:border-box;padding:12px 8px 12px 0;position:relative;text-align:left}.table-container .table__head__cell--resizable{padding-right:24px}.table-container .table__head__cell--selectable{width:34px}.table-container .table__head__cell:nth-last-child(2){padding-right:24px}.table-container .table__head__cell__resizer{cursor:col-resize;padding-left:12px;padding-right:12px;position:absolute;right:0;top:50%;transform:translateY(-50%);}.table-container .table__head__cell__resizer+.text{padding-right:12px}.table-container .table__head__spacer{border-bottom:1px solid rgba(0, 15, 30, 0.1);box-sizing:border-box;min-width:24px;width:24px}.table-container .table__head__spacer:empty{pointer-events:none}.table-container .table__head__cell,.table-container .table__head__spacer{background-color:#FFFFFF;position:sticky;top:0}.table-container .table__head .column-selector-button{all:unset;border-left:1px solid rgba(0, 15, 30, 0.1);cursor:pointer;height:100%;inset:0;left:auto;position:absolute;width:50px}.table-container .table__head .column-selector-button:hover,.table-container .table__head .column-selector-button:active{background:rgba(0, 15, 30, 0.05)}.table-container .table__body__cell{border-bottom:1px solid rgba(0, 15, 30, 0.1);overflow-wrap:break-word;padding:12px 8px 12px 0}.table-container .table__body__cell__checkbox{vertical-align:top}.table-container .table__body__spacer{border-bottom:1px solid rgba(0, 15, 30, 0.1);min-width:24px;position:relative;width:24px}.table-container .table__body__spacer:empty{pointer-events:none}.table-container .table__body__row{position:relative}.table-container .table__body__row--clickable{cursor:pointer}.table-container .table__body__row--hovered{background-color:#F4F8FE}.table-container .table__body__row--clickable.table__body__row--hovered .row__cta__shadow{background:linear-gradient(270deg, #F4F8FE 0%, rgba(255, 255, 255, 0) 100%)}.table-container .table__body__row--clickable.table__body__row--hovered .row__cta__slot{background-color:#F4F8FE}.table-container .table__body .row__cta{align-items:center;bottom:0;display:flex;position:absolute;right:24px;top:0}.table-container .table__body .row__cta__shadow{background:linear-gradient(270deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 100%);height:100%;pointer-events:none;width:32px}.table-container .table__body .row__cta__slot{align-items:center;background-color:#FFFFFF;display:flex;height:100%;white-space:nowrap}.table-container .table__body__row:last-of-type .table__body__spacer,.table-container .table__body__row:last-of-type .table__body__cell{border-bottom:0}.table-container .pagination-wrapper{background:#F8F8F8;border-top:1px solid rgba(0, 15, 30, 0.1);padding-block:8px;padding-inline:24px}.vertical-line{border-right:1px solid rgba(0, 15, 30, 0.2);height:16px;pointer-events:none}";
const GravityTableStyle0 = gravityTableCss;

const GravityTable = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.clickRow = createEvent(this, "clickRow", 5);
        this.columnChange = createEvent(this, "columnChange", 5);
        this.columnResize = createEvent(this, "columnResize", 5);
        this.columnSort = createEvent(this, "columnSort", 5);
        this.firstPage = createEvent(this, "firstPage", 5);
        this.lastPage = createEvent(this, "lastPage", 5);
        this.nextPage = createEvent(this, "nextPage", 5);
        this.numberOfRowsChange = createEvent(this, "numberOfRowsChange", 5);
        this.previousPage = createEvent(this, "previousPage", 5);
        this.selectRow = createEvent(this, "selectRow", 5);
        this.numberOfRowsOptions = [
            {
                id: '5',
                label: '5',
            },
            {
                id: '10',
                label: '10',
            },
            {
                id: '20',
                label: '20',
            },
        ];
        this.isColumnWidthLocked = false;
        this.xssOptions = {
            whiteList: Object.assign(Object.assign({ slot: ['name'] }, gravityXSSWhitelist), lib.exports.whiteList),
            onTagAttr: function (tag, name, value) {
                if (name === 'style') {
                    return `${name}="${value}"`;
                }
            },
        };
        this.handleResize = (event) => {
            const target = event.target;
            this.columnInResize = target.parentElement;
            this.nextColumnInResize = this.columnInResize.nextElementSibling;
            this.boundHandleResizeEnd = this.createResizeHandler.bind(this);
            global$1.window.addEventListener('mousemove', this.handleMouseMove);
            global$1.window.addEventListener('mouseup', this.boundHandleResizeEnd);
            this.mouseStartX = event.pageX;
            this.startColumnWidth = this.columnInResize.offsetWidth - this.getPaddingDiff(this.columnInResize);
            if (this.nextColumnInResize) {
                this.startNextColumnInResizeWidth =
                    this.nextColumnInResize.offsetWidth - this.getPaddingDiff(this.nextColumnInResize);
            }
        };
        this.handleMouseMove = (event) => {
            if (event.buttons !== 1)
                return;
            const diffX = event.pageX - this.mouseStartX;
            const newWidth = this.startColumnWidth + diffX;
            if (!this.columnMinWidth || newWidth >= this.columnMinWidth) {
                this.columnInResize.style.width = `${newWidth}px`;
                if (this.nextColumnInResize) {
                    const newNextColumnWidth = this.startNextColumnInResizeWidth - diffX;
                    this.nextColumnInResize.style.width = `${newNextColumnWidth}px`;
                }
            }
            if (this.columnMinWidth) {
                this.checkColumnsMinWidth();
            }
        };
        this.createResizeHandler = () => {
            const resizedColumnWidth = this.columnInResize.style.width === 'auto' ? 'auto' : parseInt(this.columnInResize.style.width, 10);
            const isAutoWidth = this.columnInResize.style.width === 'auto';
            if (resizedColumnWidth === this.startColumnWidth)
                return;
            const columns = Array.from(this.tableElement.querySelectorAll('[data-field]'));
            const allColumns = columns.map((column) => ({
                width: isAutoWidth ? 'auto' : column.offsetWidth.toString(),
                field: column.getAttribute('data-field'),
            }));
            this.columnResize.emit({
                columns: allColumns,
            });
            global$1.window.removeEventListener('mousemove', this.handleMouseMove);
            global$1.window.removeEventListener('mouseup', this.boundHandleResizeEnd);
            this.boundHandleResizeEnd = null; // Clear the reference after removing the event listener
        };
        this.columnMinWidth = 80;
        this.columns = undefined;
        this.currentPage = 1;
        this.data = undefined;
        this.displayedColumns = undefined;
        this.height = undefined;
        this.itemsRangeLabel = undefined;
        this.layout = 'fixed';
        this.options = {};
        this.selected = [];
        this.sorting = undefined;
        this.displayedData = undefined;
        this.headerHeight = 0;
        this.hoveredIndex = undefined;
        this.hoveredRow = undefined;
        this.numberOfRows = 20;
    }
    /**
     * Get on which row is hovered
     */
    handleColumnsChange() {
        this.resetDisplayedColumns();
    }
    handleDataChange() {
        this.originalData = [...this.data];
        if (this.sorting && this.options.pagination !== 'custom') {
            this.sortData(this.sorting.field, this.sorting);
        }
        this.setDisplayedData();
    }
    handleOptionsChange() {
        this.setOptions();
    }
    handleSortingChange(newValue) {
        // Performs a new sort or a reset
        if (newValue && this.options.pagination !== 'custom') {
            this.sortData(newValue.field, newValue);
        }
        else if (!newValue) {
            this.resetSorting();
            this.setDisplayedData();
        }
    }
    handlePageChange() {
        if (this.options.pagination && this.options.pagination == 'custom') {
            return;
        }
        this.setDisplayedData();
    }
    /**
     * Get on which row is hovered
     */
    async getHoveredRow() {
        return this.hoveredRow;
    }
    renderTable() {
        return (h("div", { class: "table-container", style: { height: this.height } }, h("div", { class: "table-container__scroll-area" }, h("table", { class: `table table--${this.isColumnWidthLocked ? 'fixed' : this.layout}`, ref: (el) => {
                this.tableElement = el;
            } }, h("tbody", { class: "table__body" }, this.displayedData.map((dataRow, index) => {
            return (h("tr", { class: `
                      table__body__row
                      ${this.options.clickableRows ? 'table__body__row--clickable' : ''}
                      ${this.hoveredIndex == index && this.options.clickableRows ? 'table__body__row--hovered' : ''}
                    `, onClick: () => this.clickRow.emit(dataRow), onMouseEnter: () => {
                    this.hoveredIndex = index;
                    this.hoveredRow = dataRow;
                }, onMouseLeave: () => {
                    this.hoveredIndex = undefined;
                    this.hoveredRow = undefined;
                } }, h("td", { class: "table__body__spacer" }), this.options.selectableField ? (h("td", { class: "table__body__cell" }, h("gravity-checkbox", { value: !!this.selected.find((el) => dataRow[this.options.selectableField] == el), onChanged: ($event) => this.handleSelection($event, dataRow), disabled: !!('disabled' in dataRow && dataRow.disabled), class: "table__body__cell__checkbox" }))) : null, this.columns.map((column) => {
                if (!this.displayedColumns.includes(column.field)) {
                    return;
                }
                return (h("td", { class: "table__body__cell" }, h("gravity-text", { class: "text", color: 'disabled' in dataRow && dataRow.disabled && this.options.selectableField
                        ? 'dark-muted'
                        : 'dark', size: "x-small", innerHTML: xss(dataRow[column.field], this.xssOptions) })));
            }), h("td", { class: "table__body__spacer" }, this.hoveredIndex == index && this.element.querySelector('[slot="row-cta"]') ? (h("div", { class: "row__cta" }, h("div", { class: "row__cta__shadow" }), h("div", { class: "row__cta__slot" }, h("slot", { name: "row-cta" })))) : null)));
        })), h("thead", { class: "table__head" }, !this.options.hideHeader ? (h("tr", { ref: (el) => (this.headerRow = el), class: "table__head__row--columns" }, h("th", { class: "table__head__spacer" }), this.options.selectableField ? (h("th", { class: "table__head__cell table__head__cell--selectable" }, h("gravity-checkbox", { ref: (el) => (this.selectAllCheckbox = el), onChanged: (event) => this.handleAllSelection(event) }))) : null, this.columns
            .filter((column) => this.displayedColumns.includes(column.field))
            .map((column, index, filteredColumns) => {
            var _a;
            return (h("th", { class: `table__head__cell ${this.options.resizable ? 'table__head__cell--resizable' : ''}`, style: { width: (_a = column.width) !== null && _a !== void 0 ? _a : 'auto' }, "data-field": column.field }, this.options.resizable && index !== filteredColumns.length - 1 ? (h("div", { class: "table__head__cell__resizer", onMouseDown: (event) => this.handleResize(event) }, h("div", { class: "vertical-line" }))) : null, this.renderColumnTitle(column)));
        }), h("th", { key: "dropdown", class: "table__head__spacer" }, this.renderDisplayColumnsButton()))) : null, !!this.options.selectableField && this.selected.length ? (h("tr", { class: "selection-container" }, h("th", { class: "selection-container__spacer", style: { top: `${this.headerHeight}px` } }), h("th", { class: "selection-container__cell", style: { top: `${this.headerHeight}px` } }, h("gravity-checkbox", { value: 'true', onChanged: (event) => this.handleAllSelection(event) })), h("th", { class: "selection-container__cell", colSpan: this.displayedColumns.length + 1, style: { top: `${this.headerHeight}px` } }, h("div", { class: "selection-container__row" }, h("gravity-text", { class: "text", color: "primary-lighter", size: "x-small" }, this.selected.length, " ", this.selected.length > 1 ? 'items' : 'item', " selected"), h("slot", { name: "selection-cta" }))))) : null))), this.renderPagination()));
    }
    renderPagination() {
        if (!this.options.pagination) {
            return null;
        }
        const itemRangeLabel = `${(this.currentPage - 1) * this.numberOfRows + 1}-${this.currentPage * this.numberOfRows > this.data.length ? this.data.length : this.currentPage * this.numberOfRows} of ${this.data.length} items`;
        const renderedItemRangeLabel = this.options.pagination != 'custom' ? itemRangeLabel : undefined;
        return (h("div", { class: "pagination-wrapper" }, h("gravity-pagination", { currentPage: this.currentPage, itemsRangeLabel: this.itemsRangeLabel || renderedItemRangeLabel, itemsPerPage: this.numberOfRows, itemsPerPageOptions: this.numberOfRowsOptions, onFirstPage: () => this.goToFirstPage(), onItemPerPageOptionsSelected: (event) => this.handleNumberOfRowsChange(event), onLastPage: () => this.goToLastPage(), onNextPage: () => this.goToNextPage(), onPreviousPage: () => this.goToPreviousPage() })));
    }
    renderColumnTitle(column) {
        var _a, _b;
        const title = (h("gravity-text", { class: "text", weight: "medium", size: "x-small", color: "dark", title: column.title }, h("div", { class: `text__container text__container--clamp-${this.options.multilineHeader ? 'multi' : 'single'}` }, column.title)));
        if (!column.sortable) {
            return title;
        }
        const sortButtonClasses = [`sort-button`, column.field === ((_a = this.sorting) === null || _a === void 0 ? void 0 : _a.field) && `sort-button--sorted`];
        return (h("button", { class: sortButtonClasses.filter(Boolean).join(' '), "data-sorted": column.field === ((_b = this.sorting) === null || _b === void 0 ? void 0 : _b.field), onClick: () => this.sortDataOnClick(column), title: column.title }, title, this.renderSortingIcon(column)));
    }
    renderSortingIcon(column) {
        var _a, _b;
        if (column.field === ((_a = this.sorting) === null || _a === void 0 ? void 0 : _a.field) && ((_b = this.sorting) === null || _b === void 0 ? void 0 : _b.asc)) {
            return h("gravity-icon", { size: "xxx-small", class: "sort-button__icon", name: "sort-asc", color: "dark" });
        }
        else if (this.sorting && column.field === this.sorting.field && !this.sorting.asc) {
            return h("gravity-icon", { size: "xxx-small", class: "sort-button__icon", name: "sort-desc", color: "dark" });
        }
        return h("gravity-icon", { size: "xxx-small", class: "sort-button__icon", name: "arrows-down-up", color: "dark-subtle" });
    }
    renderDisplayColumnsButton() {
        var _a, _b;
        if ((_a = this.options.columnSelector) === null || _a === void 0 ? void 0 : _a.hide) {
            return;
        }
        return [
            h("button", { class: "column-selector-button", id: "column-selector-button" }, h("gravity-icon", { name: "dots", size: "xx-small" })),
            h("gravity-dropdown", { for: "column-selector-button", queryType: ((_b = this.options.columnSelector) === null || _b === void 0 ? void 0 : _b.filterable) ? 'filter' : false, options: this.columns
                    .map((column) => ({ id: column.field, label: column.title }))
                    .filter((option) => option.label), selected: this.displayedColumns, onDropdownOptionSelected: (event) => this.handleDisplayColumnChange(event.detail), selectionBehavior: "multi", positionStrategy: "fixed" }),
        ];
    }
    lockColumnWidth() {
        if (!this.tableElement || this.isColumnWidthLocked) {
            return;
        }
        const headerCells = this.tableElement.querySelectorAll('th.table__head__cell');
        headerCells.forEach((cell) => {
            var _a;
            const column = this.columns.find((col) => col.field === cell.getAttribute('data-field'));
            cell.style.width = (_a = column === null || column === void 0 ? void 0 : column.width) !== null && _a !== void 0 ? _a : `${cell.clientWidth}px`;
        });
        this.isColumnWidthLocked = true;
    }
    unlockColumnWidth() {
        if (!this.tableElement) {
            return;
        }
        const headerCells = this.tableElement.querySelectorAll('th.table__head__cell');
        headerCells.forEach((cell) => {
            cell.style.width = '';
        });
        this.isColumnWidthLocked = false;
    }
    sortDataOnClick(column) {
        var _a, _b, _c;
        this.lockColumnWidth();
        const isSameColumn = this.sorting && column.field === this.sorting.field;
        const sorting = {
            field: column.field,
            asc: isSameColumn ? !((_a = this.sorting) === null || _a === void 0 ? void 0 : _a.asc) : true,
        };
        const direction = isSameColumn && !((_b = this.sorting) === null || _b === void 0 ? void 0 : _b.asc) ? 'none' : sorting.asc ? 'asc' : 'desc';
        // Emit the events
        this.columnSort.emit({ field: column.field, direction });
        // Early exit for custom pagination
        if (this.options.pagination === 'custom') {
            return;
        }
        // Reset sort if sorting is already done in desc order for the same column; otherwise, sort data
        isSameColumn && !((_c = this.sorting) === null || _c === void 0 ? void 0 : _c.asc) ? this.resetSorting() : this.sortData(column.field, sorting);
    }
    sortData(columnField, sorting) {
        // Find the column based on field, and then perform sorting
        const columnToSort = this.columns.find((col) => col.field === columnField);
        if (columnToSort) {
            const multiplier = sorting.asc ? 1 : -1;
            this.data.sort((a, b) => multiplier * `${a[columnToSort.field]}`.localeCompare(`${b[columnToSort.field]}`));
            this.sorting = sorting;
            this.currentPage = 1;
            this.setDisplayedData();
        }
    }
    resetSorting() {
        // Restores the data to its original state and resets the sorting
        if (Array.isArray(this.originalData)) {
            this.data = [...this.originalData];
        }
        this.sorting = undefined;
    }
    setDisplayedData() {
        if (!this.options.pagination || this.options.pagination == 'custom') {
            this.displayedData = this.data.filter((data) => data);
        }
        else {
            this.displayedData = this.data
                .filter((data) => data)
                .slice((this.currentPage - 1) * this.numberOfRows, this.currentPage * this.numberOfRows);
        }
    }
    setOptions() {
        if (this.options.numberOfRows) {
            this.numberOfRows = this.options.numberOfRows;
        }
        if (this.options.numberOfRowsOptions) {
            this.numberOfRowsOptions = this.options.numberOfRowsOptions;
        }
    }
    resetDisplayedColumns() {
        this.displayedColumns = this.columns.map((column) => column.field);
        this.unlockColumnWidth();
    }
    handleNumberOfRowsChange(event) {
        this.unlockColumnWidth();
        this.numberOfRows = parseInt(event.detail[0]);
        this.numberOfRowsChange.emit(this.numberOfRows);
        this.currentPage = 1;
        this.setDisplayedData();
    }
    goToNextPage() {
        this.lockColumnWidth();
        this.nextPage.emit();
        if (this.options.pagination && this.options.pagination == 'custom') {
            return;
        }
        if (this.currentPage + 1 > Math.ceil(this.data.length / this.numberOfRows)) {
            return;
        }
        this.currentPage = this.currentPage + 1;
        this.setDisplayedData();
    }
    goToPreviousPage() {
        this.lockColumnWidth();
        this.previousPage.emit();
        if (this.options.pagination && this.options.pagination == 'custom') {
            return;
        }
        if (this.currentPage - 1 < 1) {
            return;
        }
        this.currentPage = this.currentPage - 1;
        this.setDisplayedData();
    }
    goToFirstPage() {
        this.lockColumnWidth();
        this.firstPage.emit();
        if (this.options.pagination && this.options.pagination == 'custom') {
            return;
        }
        this.currentPage = 1;
        this.setDisplayedData();
    }
    goToLastPage() {
        this.lockColumnWidth();
        this.lastPage.emit();
        if (this.options.pagination && this.options.pagination == 'custom') {
            return;
        }
        this.currentPage = Math.ceil(this.data.length / this.numberOfRows);
        this.setDisplayedData();
    }
    handleAllSelection(event) {
        if (event.detail) {
            this.selected = [];
            this.data.forEach((dataRow) => {
                if (!dataRow.disabled && this.options.selectableField) {
                    this.selected = [dataRow[this.options.selectableField], ...this.selected];
                }
            });
        }
        else {
            this.selected = [];
            if (this.selectAllCheckbox) {
                this.selectAllCheckbox.value = false;
            }
        }
        this.selectRow.emit(this.selected);
    }
    handleSelection(event, dataRow) {
        if (!this.options.selectableField) {
            return;
        }
        if (event.detail) {
            this.selected = [dataRow[this.options.selectableField], ...this.selected];
        }
        else {
            this.selected = this.selected.filter((el) => el != dataRow[this.options.selectableField]);
        }
        if (this.selected.length && this.selectAllCheckbox) {
            this.selectAllCheckbox.value = 'mixed';
        }
        else if (!this.selected.length && this.selectAllCheckbox) {
            this.selectAllCheckbox.value = false;
        }
        this.selectRow.emit(this.selected);
    }
    handleDisplayColumnChange(displayedColumns) {
        this.unlockColumnWidth();
        if (!displayedColumns.length) {
            this.displayedColumns = [...this.displayedColumns];
            return;
        }
        this.displayedColumns = [...displayedColumns];
        this.columnChange.emit(this.displayedColumns);
    }
    checkColumnsMinWidth() {
        const columns = this.tableElement.querySelectorAll('.table__head__cell:not(.table__head__cell--selectable)');
        if (!columns) {
            return;
        }
        columns.forEach((columnElement) => {
            var _a;
            const paddingDiff = this.getPaddingDiff(columnElement);
            const newColumnWidth = Math.max(this.columnMinWidth, columnElement.offsetWidth - paddingDiff);
            const column = this.columns.find((col) => col.field === columnElement.getAttribute('data-field'));
            columnElement.style.width = (_a = column === null || column === void 0 ? void 0 : column.width) !== null && _a !== void 0 ? _a : `${newColumnWidth}px`;
        });
    }
    getPaddingDiff(column) {
        if (getComputedStyle(column).getPropertyValue('box-sizing') === 'border-box') {
            return 0;
        }
        const paddingLeft = parseInt(getComputedStyle(column).getPropertyValue('padding-left'), 10);
        const paddingRight = parseInt(getComputedStyle(column).getPropertyValue('padding-right'), 10);
        return paddingLeft + paddingRight;
    }
    componentWillLoad() {
        this.setOptions();
        this.setDisplayedData();
        if (!this.displayedColumns) {
            this.resetDisplayedColumns();
        }
        this.originalData = [...this.data];
        // Handles initial sorting on load, if necessary
        if (this.sorting && this.options.pagination !== 'custom') {
            this.sortData(this.sorting.field, this.sorting);
        }
    }
    componentDidLoad() {
        if (this.headerRow) {
            this.headerHeight = this.headerRow.offsetHeight;
        }
        if (this.columnMinWidth > 0) {
            this.checkColumnsMinWidth();
        }
    }
    render() {
        if (this.data && this.columns) {
            return this.renderTable();
        }
        else {
            return null;
        }
    }
    get element() { return getElement(this); }
    static get watchers() { return {
        "columns": ["handleColumnsChange"],
        "data": ["handleDataChange"],
        "options": ["handleOptionsChange"],
        "sorting": ["handleSortingChange"],
        "currentPage": ["handlePageChange"]
    }; }
};
GravityTable.style = GravityTableStyle0;

export { GravityTable as gravity_table };

//# sourceMappingURL=gravity-table.entry.js.map